<ngx-spinner [name]="'novo-produto'" type="ball-clip-rotate-pulse" [fullScreen]="false" bdColor="rgba(0, 0, 0, 0.2)">
</ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Cadastrar Produto</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <mat-horizontal-stepper labelPosition="bottom" #stepper>

            <!-- Etapa 1 -->
            <mat-step [stepControl]="produtoForm">
                <form [formGroup]="produtoForm">
                    <ng-template matStepLabel>Informações Primárias</ng-template>

                    <div class="borda">
                        <div class="row">
                            <div class="col-sm-4">
                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                    <mat-label>Tipo de Item</mat-label>
                                    <mat-select style="color: black;" formControlName="tipoItem" name="tipo_item"
                                        required>
                                        <mat-option *ngFor="let tipo of tipoItem" [value]="tipo.value">
                                            {{tipo.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="f.tipoItem.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>Unidade de Medida</mat-label>
                                            <mat-select formControlName="unidade" name="unidade_medida" required>
                                                <mat-option *ngFor="let unidade of unidadesMedidas"
                                                    [value]="unidade.value">
                                                    {{unidade.name}}
                                                </mat-option>
                                            </mat-select>

                                            <mat-error *ngIf="f.unidade.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-1">
                                        <button class="bt_lateral" mat-icon-button color="primary"
                                            aria-label="Novo Unidade de Medida" (click)="novoUnidadesMedida()">
                                            <mat-icon class="mat-icon-custom">control_point</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="col-auto ml-2">
                                <h1 class="customH1">Foto do Produto <div
                                        style="font-size: smaller; display: inline-block;">(520 x 410)</div>
                                </h1>
                                <div *ngIf="!f.img64.value">
                                    <button mat-stroked-button color="primary" (click)="uploadFoto()">
                                        <mat-icon>add_a_photo</mat-icon> Enviar foto
                                    </button>
                                </div>


                                <div class="row" *ngIf="f.img64.value">
                                    <div
                                        style="margin-top: 4px; background-color: #F0F0F0; border-radius: 5px; align-items: center; margin-left: 15px; ">
                                        <img style="max-height: 100px; margin: 4px" [src]="f.img64.value"
                                            alt="Foto do Produto" (click)="uploadFoto()" />
                                    </div>

                                    <div style="display: inline-block; margin-top: 75px;">
                                        <button mat-stroked-button color="primary" matTooltip="Editar foto"
                                            (click)="uploadFoto()">
                                            <mat-icon>mode_edit</mat-icon>
                                        </button>
                                    </div>

                                    <div style="display: inline-block; margin-top: 75px;">
                                        <button mat-stroked-button color="warn" matTooltip="Excluir foto"
                                            (click)="deletarFoto()">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Descrição (Nome do Produto)</mat-label>
                                    <input type="text" matInput formControlName="nomeProduto" maxlength="100"
                                        (keypress)="omit_special_char($event)" required>
                                    <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;"> Não
                                        são permitidos acentos ou caracteres especiais </mat-hint>
                                    <mat-error *ngIf="f.nomeProduto.errors">
                                        Campo obrigatório
                                    </mat-error>

                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <div class="row">

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>Grupo</mat-label>
                                            <mat-select formControlName="grupo" name="gp" required>
                                                <mat-option *ngFor="let gp of grupos" [value]="gp.value">
                                                    {{gp.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.grupo.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-1">
                                        <button class="bt_lateral" mat-icon-button color="primary"
                                            aria-label="Novo Grupo" (click)="novoProduto()">
                                            <mat-icon class="mat-icon-custom">control_point</mat-icon>
                                        </button>
                                    </div>

                                </div>
                            </div>

                            <div class="col-sm">
                                <div class="row">

                                    <div class="col-sm">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>Fornecedor Preferencial</mat-label>
                                            <mat-select formControlName="fornecedorPreferencial"
                                                name="fornecedor_preferencial">
                                                <mat-option *ngFor="let fornecedor of fornecedores"
                                                    [value]="fornecedor.value">
                                                    {{fornecedor.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.fornecedorPreferencial.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-1">
                                        <button class="bt_lateral" mat-icon-button color="primary"
                                            aria-label="Novo Grupo" (click)="novoFornecedor()">
                                            <mat-icon class="mat-icon-custom">control_point</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Descrição Complementar</mat-label>
                                    <input type="text" matInput formControlName="descricaoComplementar" maxlength="200" required>
                                    <mat-error *ngIf="f.descricaoComplementar.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-sm">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Referência</mat-label>
                                    <input type="text" matInput formControlName="referencia" maxlength="100">
                                    <mat-error *ngIf="f.referencia.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Código de Barras</mat-label>
                                    <input type="text" matInput formControlName="codBarras"
                                        (change)="validaCodigoBarras()" maxlength="13">
                                    <mat-error *ngIf="f.codBarras.errors?.required">
                                        Campo obrigatório
                                    </mat-error>
                                    <mat-error *ngIf="!f.codBarras.errors?.statusCodigoBarras">
                                        Este código já consta no sistema
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row mt-4">
                    <div class="col-sm text-right">
                        <button mat-mini-fab color="primary" aria-label="Avançar" (click)="paginas(true, 1)"
                            matTooltip="Avançar">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-step>


            <!-- Etapa 2 -->
            <mat-step [stepControl]="produtoForm">
                <form [formGroup]="produtoForm">
                    <ng-template matStepLabel>Informações de Venda</ng-template>

                    <div class="row">
                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Valor</mat-label>
                                <input matInput currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                    formControlName="valor" maxlength="20" (ngModelChange)="alteracaoValor(true)"
                                    required>
                                <mat-error *ngIf="f.valor.errors?.required">
                                    Campo obrigatório
                                </mat-error>

                                <mat-error *ngIf="f.valor.errors?.min">
                                    O Valor não pode ser R$ 0,00
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Valor Atacado</mat-label>
                                <input matInput currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                    formControlName="valorAtacado" maxlength="20"
                                    (ngModelChange)="alteracaoValor(false)">
                                <mat-error *ngIf="f.valorAtacado.errors?.required">
                                    Campo obrigatório
                                </mat-error>

                                <mat-error *ngIf="f.valorAtacado.errors?.max">
                                    O valor atacado não pode ser maior do que o valor do produto
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Quantidade para Atacado</mat-label>
                                <input type="number" matInput formControlName="quantidadeAtacado" [min]="0">
                                <mat-error *ngIf="f.quantidadeAtacado.errors?.required">
                                    Campo obrigatório
                                </mat-error>

                                <mat-error *ngIf="f.quantidadeAtacado.errors?.min">
                                    A quantidade não pode ser 0
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Quantidade Estoque</mat-label>
                                <input type="number" matInput formControlName="quantidadeEstoque" [min]="0" maxlength="20">
                                <mat-error *ngIf="f.quantidadeEstoque.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div> -->

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Quantidade mínima (Alerta estoque)</mat-label>
                                <input type="number" matInput formControlName="quantidadeMinimaAlertaEstoque" [min]="0" maxlength="20">
                                <mat-error *ngIf="f.quantidadeMinimaAlertaEstoque.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Quantidade Mínima (Venda)</mat-label>
                                <input type="number" matInput formControlName="quantidadeMinima" [min]="0"
                                    maxlength="20">
                                <mat-error *ngIf="f.quantidadeMinima.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Quantidade Máxima (Venda)</mat-label>
                                <input type="number" matInput formControlName="quantidadeMaxima" [min]="0"
                                    maxlength="20">
                                <mat-hint align="start"><strong>9999 para ilimitado</strong> </mat-hint>
                                <mat-error *ngIf="f.quantidadeMaxima.errors">
                                    Campo obrigatório
                                </mat-error>
                                <mat-error *ngIf="f.quantidadeMaxima.errors?.min">
                                    O mínimo deve ser 1
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Identificador</mat-label>
                                <input type="number" matInput formControlName="identificador" [min]="0" maxlength="20">
                                <mat-error *ngIf="f.identificador.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Código</mat-label>
                                <input type="number" matInput formControlName="codigo" [min]="0" maxlength="20"
                                    required>
                                <mat-hint align="start"><strong>Parâmetro à confirmar</strong> </mat-hint>
                                <mat-error *ngIf="f.codigo.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Lucro Bruto</mat-label>
                                <input currencyMask
                                    [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                    matInput formControlName="lucroBruto" maxlength="20">
                                <mat-error *ngIf="f.lucroBruto.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Comissão</mat-label>
                                <input currencyMask
                                    [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                    matInput formControlName="comissao" maxlength="20">
                                <mat-error *ngIf="f.comissao.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Custo de Compra</mat-label>
                                <input matInput currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                    formControlName="custoCompra" maxlength="20">
                                <mat-error *ngIf="f.custoCompra.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="col-xs-auto col-md-2">
                            <mat-form-field appearance="outline" [floatLabel]="'always'">
                                <mat-label>Custo Médio</mat-label>
                                <input matInput currencyMask
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                    formControlName="custoMedio" maxlength="20">
                                <mat-error *ngIf="f.custoMedio.errors">
                                    Campo obrigatório
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </form>

                <div class="row mt-4">
                    <div class="col-auto">
                        <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 0)"
                            matTooltip="Voltar">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                    </div>

                    <div class="col-sm text-right">
                        <button mat-mini-fab color="warn" aria-label="Salvar" (click)="cadastrar()" matTooltip="Salvar"
                            matTooltipClass="tooltip-red">
                            <mat-icon>check</mat-icon>
                        </button>
                    </div>

                    <div class="col-auto">
                        <button mat-mini-fab color="primary" aria-label="Avançar" (click)="paginas(true, 2)"
                            matTooltip="Avançar">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-step>

            <!-- Etapa 3 DESABILITADA IPANEMA -->
            <!-- <mat-step [stepControl]="produtoForm">
                <form [formGroup]="produtoForm">
                    <ng-template matStepLabel>Informações Tributárias</ng-template>
                    <div class="row">
                        <div class="col-sm">
                            <div class="row mt-4">
                                <div class="col-auto">
                                    <h1 class="customH1">Situação Tributária da NFe (Contribuinte)</h1>
                                </div>
                                <div class="col-sm">
                                    <hr />
                                </div>
                            </div>

                            <div class="borda">
                                <div class="row">
                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CST NFe</mat-label>
                                            <mat-select formControlName="cstNFe" name="cst_nfe"
                                                matTooltip="Código de Situação Tributária - Nota Fiscal Eletrôica"
                                                required>
                                                <mat-option *ngFor="let cst of cstNFe" [value]="cst.CST"
                                                    [title]="cst.DESCRICAO">
                                                    {{cst.CST}} - {{cst.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cstNFe.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CSOSN NFe</mat-label>
                                            <mat-select formControlName="csosnNFe" name="csosn_nfe"
                                                matTooltip="Código de Situação da Operação do Simples Nacional - Nota Fiscal Eletrôica"
                                                required>
                                                <mat-option *ngFor="let csosnN of csosnNFe" [value]="csosnN.CSOSN"
                                                    [title]="csosnN.DESCRICAO">
                                                    {{csosnN.CSOSN}} - {{csosnN.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.csosnNFe.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>Taxa ICMS/ISS</mat-label>
                                            <mat-select formControlName="taxaICMSISS" name="taxa_icms_iss"
                                                matTooltip="Taxa de Circulação de Mercadorias e Prestação de Serviços / Imposto sobre o Serviço"
                                                required>
                                                <mat-option *ngFor="let tx of taxaICMSISS" [value]="tx.value">
                                                    {{tx.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.taxaICMSISS.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CFOP NF</mat-label>
                                            <mat-select formControlName="cfopNF" name="cfop_nf"
                                                matTooltip="Código Fiscal de Operações e Prestações - Nota Fiscal"
                                                required>
                                                <mat-option *ngFor="let cfopNF of cfopNF" [value]="cfopNF.CFOP"
                                                    [title]="cfopNF.DESCRICAO">
                                                    {{cfopNF.CFOP}} - {{cfopNF.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cfopNF.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm">
                            <div class="row mt-4">
                                <div class="col-auto">
                                    <h1 class="customH1">Situação Tributária NFCe (Cupom Eletrônico)</h1>
                                </div>
                                <div class="col-sm">
                                    <hr />
                                </div>
                            </div>

                            <div class="borda">
                                <div class="row">
                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CST CFe</mat-label>
                                            <mat-select formControlName="cstCFe" name="cst_cfe"
                                                matTooltip="Código de Situação Tributária - Cupom Eletrôico" required>
                                                <mat-option *ngFor="let cst of cstCFe" [value]="cst.CST"
                                                    [title]="cst.DESCRICAO">
                                                    {{cst.CST}} - {{cst.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cstCFe.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CSOSN CFe</mat-label>
                                            <mat-select formControlName="csosnCFe" name="csosn_cfe"
                                                matTooltip="Código de Situação da Operação do Simples Nacional - Cupom Eletrôico"
                                                required>
                                                <mat-option *ngFor="let cosnC of csosnCFe" [value]="cosnC.CSOSN"
                                                    [title]="cosnC.DESCRICAO">
                                                    {{cosnC.CSOSN}} - {{cosnC.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.csosnCFe.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>Taxa ICMS/ISS CFe</mat-label>
                                            <mat-select formControlName="taxaICMSISSCFe" name="taxa_icms_iss"
                                                matTooltip="Taxa de Circulação de Mercadorias e Prestação de Serviços / Imposto sobre o Serviço - Cupom Eletrôico"
                                                required>
                                                <mat-option *ngFor="let txc of taxaICMSISSCFe" [value]="txc.value">
                                                    {{txc.name}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.taxaICMSISSCFe.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-auto">
                                        <mat-form-field appearance="fill" [floatLabel]="'always'">
                                            <mat-label>CFOP ECF</mat-label>
                                            <mat-select formControlName="cfopECF" name="cfop_ecf"
                                                matTooltip="Código Fiscal de Operações e Prestações - Escritura Contábill Fiscal"
                                                required>
                                                <mat-option *ngFor="let cfop of cfopECF" [value]="cfop.CFOP"
                                                    [title]="cfop.DESCRICAO">
                                                    {{cfop.CFOP}} - {{cfop.DESCRICAO}}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error *ngIf="f.cfopECF.errors">
                                                Campo obrigatório
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-auto">
                            <h1 class="customH1">Demais Informações</h1>
                        </div>
                        <div class="col-sm">
                            <hr />
                        </div>
                    </div>

                    <div class="borda">
                        <div class="row">
                            <div class="col-auto">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>NCM</mat-label>
                                    <input type="text" matInput formControlName="ncm"
                                        matTooltip="Nomeclatura Comum do Mercosul" maxlength="8" required>
                                    <mat-error *ngIf="f.ncm.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>CEST</mat-label>
                                    <input type="text" matInput formControlName="cest"
                                        matTooltip="Código Especificador da Situação Tributária" maxlength="20">
                                    <mat-error *ngIf="f.cest?.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row mt-4">
                    <div class="col-auto">
                        <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 1)"
                            matTooltip="Voltar">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                    </div>

                    <div class="col-sm text-right">
                        <button mat-mini-fab color="primary" aria-label="Avançar" (click)="paginas(true, 3)"
                            matTooltip="Avançar">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-step> -->

            <!-- Etapa 4 DESABILITADA IPANEMA-->
            <!-- <mat-step [stepControl]="produtoForm">
                <form [formGroup]="produtoForm">
                    <ng-template matStepLabel>Informações Gerais</ng-template>
                    <div class="borda">
                        <div class="row">
                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>COFINS</mat-label>
                                    <input currencyMask
                                        [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                        matInput formControlName="cofins"
                                        matTooltip="Contribuição para o Financiamento da Seguridade Social"
                                        maxlength="20">
                                    <mat-error *ngIf="f.cofins.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                    <mat-label>CST COFINS</mat-label>
                                    <mat-select formControlName="cstCOFINS" name="csosn_cfe"
                                        matTooltip="Código Especificador da Situação Tributária - Contribuição para o Financiamento da Seguridade Social">
                                        <mat-option *ngFor="let cst_cofins of cstCOFINS"
                                            [value]="cst_cofins.CST_COFINS">
                                            {{cst_cofins.CST_COFINS}} - {{cst_cofins.DESCRICAO}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="f.cstCOFINS.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>PIS</mat-label>
                                    <input currencyMask
                                        [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                        matInput formControlName="pis" matTooltip="Programa Integração Social"
                                        maxlength="20">
                                    <mat-error *ngIf="f.pis.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                    <mat-label>CST PIS</mat-label>
                                    <mat-select formControlName="cstPIS" name="csosn_cfe"
                                        matTooltip="Código Especificador da Situação Tributária - Programa Integração Social">
                                        <mat-option *ngFor="let cst_pis of cstPIS" [value]="cst_pis.CST_PIS">
                                            {{cst_pis.CST_PIS}} - {{cst_pis.DESCRICAO}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="f.cstPIS.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Código ANP</mat-label>
                                    <input type="text" matInput formControlName="codigoANP" name="codAnp"
                                        matTooltip="Agência Nacional do Petróleo" maxlength="20">
                                    <mat-error *ngIf="f.codigoANP.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>


                    <div class="row mt-4">
                        <div class="col-auto">
                            <h1 class="customH1">Natureza da Receita</h1>
                        </div>
                        <div class="col-sm">
                            <hr />
                        </div>
                    </div>

                    <div class="borda">
                        <div class="row">
                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>MVA</mat-label>
                                    <input currencyMask
                                        [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                        matInput formControlName="mva" matTooltip="Margem de Valor Agregado"
                                        maxlength="20">
                                    <mat-error *ngIf="f.mva.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>ICMS Efetivo</mat-label>
                                    <input currencyMask
                                        [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                        matInput formControlName="icmsEfetivo"
                                        matTooltip="Imposto sobre Circulação de Mercadorias e Serviços" maxlength="20">
                                    <mat-error *ngIf="f.icmsEfetivo.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>IAT</mat-label>
                                    <input type="text" matInput formControlName="iat" name="iat"
                                        matTooltip="Índice de Arredondamento ou Truncamento" maxlength="20">
                                    <mat-error *ngIf="f.iat.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>IPPT</mat-label>
                                    <input type="text" matInput formControlName="ippt" name="ippt"
                                        matTooltip="Indicador de Produção Própria ou de Terceiro" maxlength="20">
                                    <mat-error *ngIf="f.ippt.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col-auto">
                            <h1 class="customH1">IPI</h1>
                        </div>
                        <div class="col-sm">
                            <hr />
                        </div>
                    </div>

                    <div class="borda">
                        <div class="row">
                            <div class="col-auto">
                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                    <mat-label>Tipo IPI</mat-label>
                                    <mat-select formControlName="tipoIPI" name="tipo_ipi"
                                        matTooltip="Imposto sobre Produtos Industrializados">
                                        <mat-option *ngFor="let tipo_IPI of tipoIPI" [value]="tipo_IPI.value">
                                            {{tipo_IPI.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="f.tipoIPI.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>IPI</mat-label>
                                    <input currencyMask
                                        [options]="{ prefix: '% ', precision : 2, decimal: ',', align: 'left', allowNegative: false }"
                                        matInput formControlName="ipi" maxlength="20">
                                    <mat-error *ngIf="f.ipi.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                    <mat-label>CST IPI</mat-label>
                                    <mat-select formControlName="cstIPI" name="cst_ipi"
                                        matTooltip="Código de Situação Tributária - Imposto sobre Produtos Industrializados">
                                        <mat-option *ngFor="let cst_ipi of cstIPI" [value]="cst_ipi.value">
                                            {{cst_ipi.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="f.cstIPI.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="fill" [floatLabel]="'always'">
                                    <mat-label>CENQ</mat-label>
                                    <mat-select formControlName="cenq" name="cenq"
                                        matTooltip="Código de Enquadramento Legal do IPI">
                                        <mat-option *ngFor="let cenq_ of cenq" [value]="cenq_.CENQ">
                                            {{cenq_.CENQ}} - {{cenq_.DESCRICAO}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error *ngIf="f.cenq.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Exc.Fiscal</mat-label>
                                    <input type="text" matInput formControlName="excFiscal" maxlength="20">
                                    <mat-error *ngIf="f.excFiscal.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row mt-4">
                    <div class="col-auto">
                        <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 2)"
                            matTooltip="Voltar">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                    </div>

                    <div class="col-sm text-right">
                        <div class="row">
                            <div class="col-sm text-right">
                                <button mat-mini-fab color="warn" aria-label="Salvar" (click)="cadastrar()"
                                    matTooltip="Salvar" matTooltipClass="tooltip-red">
                                    <mat-icon>check</mat-icon>
                                </button>
                            </div>

                            <div class="col-auto">
                                <button mat-mini-fab color="primary" aria-label="Avançar" (click)="paginas(true, 4)"
                                    matTooltip="Avançar">
                                    <mat-icon>arrow_forward</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-step> -->

            <!-- Etapa 5 -->
            <mat-step [stepControl]="produtoForm">
                <form [formGroup]="produtoForm">
                    <ng-template matStepLabel>Período Promocional</ng-template>
                    <div class="borda">
                        <div class="row">
                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Valor</mat-label>
                                    <input matInput currencyMask
                                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                        formControlName="valorCopia" maxlength="20">
                                </mat-form-field>
                            </div>

                            <div class="col-xs-auto col-md-2">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Valor Promocional</mat-label>
                                    <input matInput currencyMask
                                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }"
                                        formControlName="valorPromocional" maxlength="20"
                                        (ngModelChange)="alteracaoValorPromocional()">
                                    <mat-error *ngIf="f.valorPromocional.errors?.max">
                                        O valor promocional não pode ser maior do que o valor do produto
                                    </mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-auto">
                                <mat-form-field appearance="outline" [floatLabel]="'always'">
                                    <mat-label>Período</mat-label>

                                    <mat-date-range-input [rangePicker]="picker">
                                        <input matStartDate placeholder="Data Inicial"
                                            formControlName="periodoPromocionalInicial">
                                        <input matEndDate placeholder="Data Final"
                                            formControlName="periodoPromocionalFinal">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>

                                    <mat-error
                                        *ngIf="f.periodoPromocionalInicial.errors || f.periodoPromocionalFinal.errors">
                                        Campo obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row mt-4">
                    <div class="col-auto">
                        <button mat-mini-fab color="primary" aria-label="Voltar" (click)="paginas(false, 3)"
                            matTooltip="Voltar">
                            <mat-icon>arrow_back</mat-icon>
                        </button>
                    </div>

                    <div class="col-sm text-right">
                        <button mat-mini-fab color="warn" aria-label="Salvar" (click)="cadastrar()"
                            matTooltipClass="tooltip-red" matTooltip="Salvar">
                            <mat-icon>check</mat-icon>
                        </button>
                    </div>
                </div>
            </mat-step>

        </mat-horizontal-stepper>
    </mat-card-content>
</mat-card>